import React from "react"
import { useSelector } from "react-redux"
import { Grid, Typography } from "@material-ui/core"
import ConnectedPreferenceCenter from "@root/pages/components/ConnectedPreferenceCenter"
import { RootState, useAppDispatch } from "@root/store"
import { selectChannel, selectPreferenceCenters } from "@root/store/selectors"
import { loadPreferenceCenters } from "@root/store/thunks"

export interface Props {
  id: string
}

const Preferences: React.FC<Props> = ({ id }) => {
  const dispatch = useAppDispatch()
  const channel = useSelector(selectChannel)
  const metadata = useSelector((state: RootState) => state.metadata)
  const preferences = useSelector(selectPreferenceCenters)
  const definition = preferences.find((pref) => pref.id === id)

  React.useEffect(() => {
    dispatch(loadPreferenceCenters())
  }, [dispatch])

  if (!channel) {
    return (
      <Grid container justifyContent="center" alignItems="center">
        <Grid item md={6} sm={12}>
          <Typography>Cannot manage preferences when not opted in.</Typography>
        </Grid>
      </Grid>
    )
  }

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      data-qa-selector="preferences"
    >
      <Grid item md={6} sm={12}>
        {definition && <ConnectedPreferenceCenter definition={definition} />}
        {!definition && (
          <Typography variant="h4">{getLoadingStateMessage()}</Typography>
        )}
      </Grid>
    </Grid>
  )

  function getLoadingStateMessage(): string {
    switch (metadata.status) {
      case "idle":
      case "pending":
        return "Loading"
      case "fulfilled":
        return `No preference center with ID: ${id}`
      case "rejected":
        return `Error loading preference centers: ${metadata.error}`
      default:
        const msg: never = metadata.status
        throw new Error(`invalid status: ${msg}`)
    }
  }
}

export default Preferences
